import * as Types from '../types/Ticket';
import {PAGINATION} from '../../constants/define';
// import HotelRequest from "../mapping/Request/HotelRequest";

const initialState = {
    isFetching: false,
    all: [],
    errors: [],
    masterData: {},
    // item: new HotelRequest().update(),
    item: {},
    data: {
        result: [],
        page_size: PAGINATION.page_size,
        page_index: PAGINATION.page_index,
        total: PAGINATION.total,
        total_page: PAGINATION.total_page,
    },
};

export default (state = initialState, action) => {
    switch (action.type) {
        case Types.TICKET_LIST_ACTION:
            return {...state, isFetching: true};
        case Types.TICKET_LIST_SUCCESS:
            return {...state, isFetching: false, data: action.tickets};
        case Types.TICKET_COMMENT_ACTION:
            return {...state, isFetching: true};
        case Types.TICKET_COMMENT_SUCCESS:
            return {...state, isFetching: false};
        case Types.TICKET_UPDATE_ACTION:
            return {...state, isFetching: true};
        case Types.TICKET_UPDATE_SUCCESS:
            return {...state, isFetching: false};
        case Types.TICKET_MASTER_DATA_ACTION:
            return {...state, isFetching: true};
        case Types.TICKET_MASTER_DATA_SUCCESS:
            return {...state, isFetching: false, masterData: action.masterData};
        case Types.TICKET_GET_TEM_ACTION:
            return {...state, isFetching: true};
        case Types.TICKET_GET_TEM_SUCCESS:
            return {...state, isFetching: false, item: action.item};
        case Types.TICKET_FAILED:
            return {...state, isFetching: false, errors: action.errors};
        case Types.TICKET_INIT:
            return initialState;
        default:
            return state;
    }
}
